import { deflate as pakoDeflate } from 'pako/dist/pako_deflate';

export var deflate = pakoDeflate;

export function supportsDeflate() {
    return true;
}




//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-drawing/dist/es/pdf/deflate.js
// module id = 705
// module chunks = 0